module.exports = __webpack_public_path__ + "96e722616ac89a2479a61d7fea2cdca1.svg";